/**
 * Локальный расчёт остатка дней. ФОЛБЭК, а не источник истины.
 *
 * Источник истины — `days_left` с бэка (`application/subscriptions/lifetime.py`):
 * только он знает про заморозку. У замороженной подписки `end_date` не двигается,
 * поэтому расчёт от `Date.now()` здесь честно вернёт убывающее число, хотя дни
 * не тратятся. Использовать только когда `sub.daysLeft` отсутствует (mock-данные).
 */
export function daysLeft(expiresAt: string | Date, now: number = Date.now()): number {
  const expMs = typeof expiresAt === 'string' ? new Date(expiresAt).getTime() : expiresAt.getTime();
  return Math.max(0, Math.ceil((expMs - now) / (1000 * 60 * 60 * 24)));
}

/**
 * Заполненность полосы срока: остаток относительно периода тарифа.
 *
 * `totalDays` обязателен намеренно. Раньше он по умолчанию был 30, и полоса вместе с
 * подписью «81 / 30» врали всем, у кого тариф не месячный или кто продлевался: остаток
 * больше периода выглядел переполнением шкалы.
 *
 * Остаток больше периода — нормально (продлился заранее), полоса просто полная.
 */
export function daysProgressRatio(days: number, totalDays: number): number {
  if (totalDays <= 0) return 0;
  return Math.min(100, Math.max(0, (days / totalDays) * 100));
}

export function trafficPercent(usedGb: number, totalGb: number | null | undefined): number {
  if (!totalGb || totalGb <= 0) return 0;
  return Math.min(100, Math.max(0, (usedGb / totalGb) * 100));
}
